// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3dloy","buttons":"SendReceipts_buttons__OuRL8","email":"SendReceipts_email__2WUJb","bookApptTitle":"SendReceipts_bookApptTitle__3BrNI"};